"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DoubleCheckIcon = function DoubleCheckIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 220 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 ".concat(size, " ").concat(size),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 102C20 151.706 60.2944 192 110 192C121 192 131 189 137 186.5L198 117C198 117 200 108.5 200 102C200 52.2944 159.706 12 110 12C60.2944 12 20 52.2944 20 102Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M107 123L150 80",
    stroke: "#18BB4F",
    strokeWidth: "4",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M70.6699 101.5L92.1688 123L135 80",
    stroke: "#18BB4F",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M137.117 186.798L198.368 117.041C198.467 116.928 198.42 116.755 198.274 116.724C195.479 116.132 174.338 112.397 154.903 130.16C135.406 147.979 136.543 182.287 136.774 186.689C136.784 186.866 137 186.932 137.117 186.798Z",
    fill: "url(#doubleCheckMark)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: size,
    height: size,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/_react.default.createElement("feOffset", {
    dy: "8"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886719 0 0 0 0 0.903646 0 0 0 0 0.9375 0 0 0 1 0"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "doubleCheckMark",
    x1: "166.207",
    y1: "151.729",
    x2: "142.974",
    y2: "129.225",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#D9DEE8"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#FDFDFD"
  }))));
};
var _default = DoubleCheckIcon;
exports.default = _default;